module.exports = __webpack_public_path__ + "img/mail.23c34fa7.svg";